import type { ReactNode } from 'react';

/**
 * A page's `<h1>`. With `actions` (or a `className` for a screen that lays
 * the row out itself) the heading shares a row with them, pushed apart.
 */
export function PageHeader({
  title,
  actions,
  centered,
  className,
}: {
  title: ReactNode;
  actions?: ReactNode;
  centered?: boolean;
  className?: string;
}) {
  const heading = (
    <h1 className={centered ? 'heading-page-center' : 'heading-page'}>
      {title}
    </h1>
  );
  if (actions === undefined && className === undefined) return heading;
  return (
    <div
      className={
        className ? `page-heading-row ${className}` : 'page-heading-row'
      }
    >
      {heading}
      {actions}
    </div>
  );
}
